__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "empresas";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(3989), __webpack_require__.e(7000)]).then(() => (() => (__webpack_require__(43989))))));
			register("react-i18next", "14.1.2", () => (Promise.all([__webpack_require__.e(7000), __webpack_require__.e(9764)]).then(() => (() => (__webpack_require__(89764))))));
			register("react-redux", "7.1.3", () => (Promise.all([__webpack_require__.e(7012), __webpack_require__.e(6399), __webpack_require__.e(7000), __webpack_require__.e(9104)]).then(() => (() => (__webpack_require__(46399))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(8911), __webpack_require__.e(7396), __webpack_require__.e(7000)]).then(() => (() => (__webpack_require__(47396))))));
			register("react", "18.3.1", () => (__webpack_require__.e(2176).then(() => (() => (__webpack_require__(72176))))));
			register("styled-components", "5.2.1", () => (Promise.all([__webpack_require__.e(36), __webpack_require__.e(7000)]).then(() => (() => (__webpack_require__(60036))))));
			initExternal(48298);
			initExternal(74144);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};